import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface BusinessPaymentConfig {
  stripeConnectId: string | null;
  loading: boolean;
}

/**
 * Hook that fetches a business's Stripe Connect ID to determine
 * whether online payments are available.
 * 
 * @param businessId - The business_id to check. If not provided, falls back to first business.
 */
export function useBusinessPaymentConfig(businessId?: string | null): BusinessPaymentConfig {
  const [stripeConnectId, setStripeConnectId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        let query = supabase
          .from("businesses")
          .select("stripe_connect_id");

        if (businessId) {
          query = query.eq("business_id", businessId);
        } else {
          query = query.limit(1);
        }

        const { data } = await query.maybeSingle();
        setStripeConnectId(data?.stripe_connect_id || null);
      } catch (err) {
        console.error("Failed to fetch business payment config:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, [businessId]);

  return { stripeConnectId, loading };
}
